/**
 * @namespace Masternavi
 * @aka SWR.Masternavi
 */
SWR.Masternavi = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'masternavi';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '#header'
  };

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Masternavi = function () {

    function Masternavi(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self.button = $('[data-target="#header-main-navi-nav"]');
      self.navi_nav = $('#header-main-navi-nav');
      self.navi_header = $('#header-main-navi-header');
      self.content_wrapper = $('#content-wrapper');

      self.headerLink = self.navi_header.find('> a[data-menubox-linksource]');
      self.areas = self.navi_nav.find('div.menubox');

      //Verweist auf den versteckten Strukturbaum der Navigation:
      self.source_lists = self.navi_nav.find('#' + self.navi_nav.attr('data-menubox-source') + '> ul.navbar-nav');

      //Die Klassen fürs Collapse werden entfernt
      self.$element.find('.navbar-collapse').removeClass('collapse');
      self.button.each(function () {
        $(this).removeAttr('data-toggle').removeClass('collapsed');
      });

      //Das Menü wird versteckt
      self.navi_nav.hide();

      if(window.isFractal) {
        //Dieser Teil ist für Fractal, da in Fractal nach dem Laden der Seite das Attribut
        //data-menubox-filter-section ausgetauscht wird und die Navi sonst die falschen Punkte anzeigen würde
        $( document ).ready(function() {
          self._renderMenu();
        });
      }else {
        //Außerhalb von Fractal passiert das selbe, allerdings früher:
        self._renderMenu();
      }

      //Nach PJAX-Navigation:
      $(document).on(Event.PJAX_DATA_API, function() {
        self.button.off('click');
        $(document).off('click' + EVENT_KEY + DATA_API_KEY);
        $(document).off('header:menu:open');
        $(document).off('header:menu:close');
        self._renderMenu();
        self._openCloseMenu();
      });

      self._openCloseMenu();
    }


    Masternavi.prototype._openCloseMenu = function _openCloseMenu() {
      var self = this;

      $(document).on('header:menu:open', function(event, data) {
        //User-Click
        //PIANO-Usability-Click senden
        try {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Das Menü wurde geöffnet',
            'click_chapter1': 'Menü',
            'click_chapter3': 'Menü wird geöffnet'
          });
        } catch (e) {
          console.warn(e);
        }

        //Wenn die Navi ausgeblendet ist, werden CSS-Änderungen vorgenommen,
        //damit bei aufgeklappter Navi kein endloses Scrolling möglich ist.

        $('.hamburger').addClass('is-active');

        $([self.navi_header, $('#playerbar'), self.content_wrapper]).each(function() {
          $(this).addClass('menu-open');
        });

        //Der Top-Button wird ausgeblendet, damit er nicht vor dem grauen Hintergrund steht
        $('a.back-to-top').fadeOut('slow');
        self.navi_nav.addClass('show');

        if(window.outerWidth >= 992) {
          //Um auf dem Desktop das Menü mittig zu platzieren muss die Breite des Scrollbalkens abgezogen werden
          self.navi_nav.find('#header-main-navi-nav-inner')
            .css('left', 'calc(50% - ((980px - ' + self._getScrollbarWidth() + 'px) / 2))')
            .css('right', 'calc(50% - ((980px - ' + self._getScrollbarWidth() + 'px) / 2))');
        }

        //Der graue Hintergrund wird eingefadet
        self.content_wrapper.removeClass('background-fade-out').addClass('background-fade-in');

        setTimeout(function(){
          self.content_wrapper.removeClass('background-fade-in');
        }, 1000);

        //Das Menü wird eingefadet
        self.navi_nav.fadeIn('slow');

        //Das Menü soll nach oben gescrollt sein
        self.navi_nav[0].scrollTop = 0;

        $('body').css('overflow-y', 'auto');
      });

      $(document).on('header:menu:close', function(event, data) {
        const $hamburger = $('.hamburger');

        if (!$hamburger.hasClass('is-active')) {
          return;
        }

        //User-Click
        //PIANO-Usability-Click senden
        try {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Das Menü wurde geschlossen',
            'click_chapter1': 'Menü',
            'click_chapter3': 'Menü wird geschlossen'
          });
        } catch (e) {
          console.warn(e);
        }

        $hamburger.removeClass('is-active');

        //Der graue Hintergrund wird ausgefadet
        self.content_wrapper.removeClass('background-fade-in').addClass('background-fade-out');

        setTimeout(function(){
          self.content_wrapper.removeClass('background-fade-out');
        }, 1000);

        //Das Menü wird ausgefadet
        self.navi_nav.fadeOut('slow', function () {
          self.navi_nav.hide().removeClass('show');

          $([self.navi_header, $('#playerbar'), self.content_wrapper]).each(function() {
            $(this).removeClass('menu-open');
          });

          $('body').css('overflow-y', '');
        });
      });

      //Bei Klick auf den Menü-Button
      self.button.on('click', function (){
        if (!self.navi_header.hasClass('menu-open')) {
          //Menü ist geschlossen

          //Wenn Suche offen Suche schließen
          if($('.navbar-search-wrapper').hasClass('search-open')) {
            $(document).trigger('header:search:close', false);
          }
          //Menü öffnen
          $(document).trigger('header:menu:open', true);
        }else {
          //Menü geöffnet und wird geschlossen
          $(document).trigger('header:menu:close', true);
        }
      });

      $(document).on('click' + EVENT_KEY + DATA_API_KEY, function(event) {
        if(self.navi_header.hasClass('menu-open')) {
          //Das auslösende Element ist nicht der Burger oder der Schließen-Button im geöffneten Menü
          //Das auslösende Element liegt nicht innerhalb des Menü-Overlays
          if ($(event.target).closest('#header-main-navi-nav-inner').length === 0 && $(event.target).closest('[data-target="#header-main-navi-nav"]').length === 0) {
            $(document).trigger('header:menu:close', false);
          }
        }
      });

      //Menü schließen
      $(document).trigger('header:menu:close', false);
    };


    /*****
     * Hauptfunktion für die Navigations-Darstellung.
     * Führt alle Funktionen aus.
     *
     * @private
     */
    Masternavi.prototype._renderMenu = function _renderMenu() {
      var self = this;

      self.section = $('body').data('menuboxFilterSection');
      console.log("Menü für", self.section);
      self.areas.each(function () {
        var $area = $(this);
        var menuboxName = $area.data('menuboxName');
        var level = 1;
        console.log(menuboxName);
        var itemsList = [];
        switch(menuboxName){
          case "section":
            //Für den Bereich "Section" sollen die Alias-Items und die Section-Items gefunden werden
            var aliasItems = self.source_lists.find('[data-menubox-filter-aliases-section="' + self.section + '"]').clone();
            var sectionItems = self.source_lists.find('[data-menubox-filter-section="' + self.section + '"]').first().clone();
            var isAliasInSectionItems = sectionItems.find('[data-menubox-filter-aliases-section="' + self.section + '"]');

            if(aliasItems.length > 0 && sectionItems.length === 0){
              //Wenn nur Alias-Items gefunden wurden, werden diese verwendet:
              itemsList = aliasItems;
            }else if(aliasItems.length > 0 && sectionItems.length > 0 && !isAliasInSectionItems) {
              //Wenn die Alias-Items nicht in den Section-Items liegen, sollen beide verwendet werden:
              itemsList = sectionItems;
              itemsList = $.merge(itemsList, aliasItems);
            }else {
              //Sonst werden die Section-Items verwendet:
              itemsList = sectionItems;
            }
            break;
          case "imswr":
            //Alle auf oberster Ebene liegenden Elemente, die in "imswr" gehören, werden geklont:
            var imswrItems = self.source_lists.find('> li[data-menuboxes*="imswr"]').clone();
            if(imswrItems.length > 0){
              itemsList = imswrItems;
            }else {
              console.log("Keine Menubox mit Namen " + menuboxName + " gefunden.");
              return;
            }
            break;
          case "tvradio":
            //Alle auf oberster Ebene liegenden Elemente, die in "tvradio" gehören, werden geklont:
            var tvradioItems = self.source_lists.find('> li[data-menuboxes*="tvradio"]').clone();
            if(tvradioItems.length > 0){
              itemsList = tvradioItems;
            }else {
              console.log("Keine Menubox mit Namen " + menuboxName + " gefunden.");
              return;
            }
            break;
        }

        console.log(itemsList);

        //Die gefundene/n Liste/n werden nun gefiltert (die Liste wird auf das entsprechende Level gekürzt):
        self._addToList(menuboxName, itemsList, level, true);

        //Elemente, die in einer Area unsichtbar sein sollen, werden entfernt:
        self._removeInvisible(menuboxName, itemsList);

        //Aus einer verschachtelten Liste werden einzelne Listen gemacht:
        itemsList = self._flattenList(itemsList, menuboxName);

        //Die Liste wird sortiert:
        itemslist = self._sortItemsOfList(itemsList, menuboxName);

        console.log(itemsList);

        //Die Listen werden dem HTML hinzugefügt
        self._addToMenu($area, itemsList);

        //Alle leeren Listenelemente werden entfernt:
        self._removeEmpty($area);

        //Menupunkte können in einem Menubereich einen anderen Namen bekommen:
        self._changeName($area, menuboxName);
      });

      //CSS-Klassen im HTML werden angepasst und Bereiche bekommen eine Überschrift:
      self._updateCssAndTitle();

      //Der Header-Link wird ausgetauscht:
      self._changeHeaderLink();

      self._addWheaterTraffic();
    };


    /***
     * In dieser Funktion wird die übergebene Liste rekursiv durchlaufen.
     * In der Ebene angekommen, bis zu der die Menüpunkte angezeigt werden sollen,
     * wird der Rest des Listenbaums entfernt.
     *
     * @param menuboxName   Name der Menübox
     * @param itemsList     Liste, die weitere Listen enthalten kann
     * @param level         Wie tief soll die Liste gehen
     * @param first         Ist es der erste Aufruf für diese Liste?
     * @private
     */
    Masternavi.prototype._addToList = function _addToList(menuboxName, itemsList, level, first) {
      var self = this;

      itemsList.each(function () {

        //Für jede Liste wird das Level beim ersten Aufruf bestimmt:
        if($(this).data('menuboxItemsLevel') && first) {
          level = $(this).data('menuboxItemsLevel');
        }
        if(!$(this).data('menuboxItemsLevel') && first) {
          level = 1;
        }
        //Wenn wir uns in der "Section" befinden, dann wird geschaut, ob es für diese ein anderes Level gibt
        if(menuboxName === "section" && $(this).data('menuboxItemsLevelSection') && first && self.section === $(this).data('menuboxFilterSection')) {
          level = $(this).data('menuboxItemsLevelSection');
        }

        level--;

        if(level <= 0) {
          //Wenn die finale Tiefe im Listenbaum erreicht ist, werden alle weiter tiefer liegenden
          //Listen entfernt:
          $(this).find('> ul').remove();
        }else {
          //Solange die finale Tiefe noch nicht erreicht ist, wird die nächst tiefere Liste ermittelt:
          self._getItem(menuboxName, $(this).find('> ul'), level, false);
        }
      });
    };


    /****
     * Diese Funktion ruft für jeden Listeneintrag der übergebenen Liste die Funktion addToList
     * auf. Außerdem filtert sie Listeneinträge aus, die nicht in die aktuelle Section sollen.
     *
     * @param menuboxName   Name der Menübox
     * @param itemsList     Liste, die weitere Listen enthalten kann
     * @param level         Wie tief soll die Liste gehen
     * @param first         Ist es der erste Aufruf für diese Liste?
     * @private
     */
    Masternavi.prototype._getItem = function _getItem(menuboxName, itemsList, level, first) {
      var self = this;

      itemsList.find('li').each(function () {

        if(menuboxName === 'section') {
          //Für jeden Listeneintrag für die "Section" wird geschaut, ob der Eintrag einer anderen Section
          //zugeordnet ist:
          var filterSection = $(this).data('menuboxFilterSection');
          var showInSection = $(this).data('menuboxShowInSection');
          if (filterSection !== self.section && 'undefined' !== typeof filterSection) {

            //Wenn der Listeneintrag einer anderen Section zugeordnet ist, wird geschaut, ob der Name der
            //aktuellen Section nicht in einem weiteren Attribut enthalten ist, oder das Attribut nicht existiert.
            //Wenn ja, dann wird der Listeneintrag entfernt.
            if ((showInSection !== self.section && 'undefined' !== typeof showInSection) || 'undefined' === typeof showInSection) {
              $(this).remove();
              return;
            }
          }
        }

        self._addToList(menuboxName, $(this), level, first);
      });
    };


    /*****
     * Die Liste wird sortiert. Dies geschieht anhand verschiedener Attribute, die die
     * Position jedes Eintrags bestimmen können.
     *
     * @param itemsList     Liste der Menüpunkte
     * @param menuboxName   Name der Menübox
     * @private
     */
    Masternavi.prototype._sortItemsOfList = function _sortItemsOfList(itemsList, menuboxName) {
      var self = this;

      if(itemsList.length > 0) {
        var items = $.makeArray($(itemsList[0]).children());
        items.sort(function (a, b) {
          var aIndex = a.getAttribute('data-menubox-priority' + '-' + menuboxName + '-' + self.section) || a.getAttribute('data-menubox-priority' + '-' + menuboxName) || a.getAttribute('data-menubox-priority') || $(a).index() + 1;
          var bIndex = b.getAttribute('data-menubox-priority' + '-' + menuboxName + '-' + self.section) || b.getAttribute('data-menubox-priority' + '-' + menuboxName) || b.getAttribute('data-menubox-priority') || $(b).index() + 1;
          return aIndex - bIndex;
        });
      }

      $(itemsList[0]).children().each(function (){
        this.remove();
      });

      $(items).each(function (){
        $(itemsList[0]).append($(this));
      });

      return itemsList;
    };


    /*****
     * Diese Funktion tauscht den Headerlink aus.
     * Es kann zusätzlich zum Link auch der Name des Links getauscht werden.
     *
     * @private
     */
    Masternavi.prototype._changeHeaderLink = function _changeHeaderLink() {
      var self = this;

      //Der erste Link wird verwendet:
      var link = self.navi_nav.find('.menubox.first a').first();
      console.log(link);

      //Wenn der Link existiert, wird dieser genommen:
      if (link.length > 0) {
        self.headerLink.attr('href', $(link).attr('href'));
      }else {
        return;
      }

      //Falls der Link einen anderen Namen bekommen soll, wird dieser verwendet:
      if (link.data('menuboxHeaderName')) {
        self.headerLink.text(link.data('menuboxHeaderName'));
      }
    };


    /*****
     * Diese Funktion entfernt unsichtbare Menüpunkte aus der Liste.
     * Sollen die Menüunterpunkte eines Listeneintrags, der unsichtbar sein soll, dennoch
     * dargestellt werden, wird nicht der gesamte Listeneintrag entfernt, sondern
     * nur der Link im unsichtbaren Eintrag. Somit wird dieser später beim "Flatten"
     * der Liste leer und entfernt.
     *
     * @param menuboxName   Name der Menübox
     * @param itemsList     Liste der Menüpunkte
     * @private
     */
    Masternavi.prototype._removeInvisible = function _removeInvisible(menuboxName, itemsList) {
      var self = this;
      var query = '[data-menubox-invisible-' + menuboxName + '="true"]';

      if(menuboxName === 'section'){
        //Wenn der Bereich die "Section" ist, dann wird die Query geändert:
        query += ',[data-menubox-invisible-section*="' + self.section + '"]';
      }

      itemsList.each(function () {
        //Für jeden obersten Listeneintrag wird geschaut, ob er entfernt werden muss:
        if ($(this).is(query)) {
          removeCheckSublist(this);
        }else {
          //Wenn nicht, dann wird geschaut, ob im Eintrag Knoten sind, die entfernt werden müssen:
          $(this).find(query).each(function() {
            removeCheckSublist(this);
          });
        }
      });

      function removeCheckSublist(item) {
        var children = $(item).find(query);
        if($(item).data('sublistVisible') || children.length > 0) {
          //Wenn der Eintrag eine sichtbare Unterliste oder weitere Kinder hat,
          //wird nur der Link des Eintrags entfernt
          $(item).find('> a').remove();

          //Danach wird für alle Kinder, die auch entfernt werden sollen
          //die Funktion erneut aufgerufen
          children.each(function() {
            removeCheckSublist(this);
          });
        }else {
          //Ansonsten wird die Liste geleert
          $(item).empty();
        }
      }
    };

    /****
     * Diese Funktion "flattet" die Liste. Das heißt, dass aus einer verschachtelten
     * Liste mit Unterlisten ein Array mit mehreren Listen entsteht. Jede dieser Listen enthält dann
     * nur noch die Listeneinträge, aber keine Unterlisten mehr.
     *
     * @param itemsList     Liste der Menüpunkte
     * @param menuboxName   Name der Menübox
     * @returns {*}         Array
     * @private
     */
    Masternavi.prototype._flattenList = function _flattenList(itemsList, menuboxName) {
      var self = this;
      var array = [];
      var ul = $('<ul class="navbar-nav container"></ul>');

      if(itemsList.length > 0) {
        if (menuboxName === "section") {

          //Wenn der Bereich "Section" ist, dann sollen alle ul in der Liste in den Array geschrieben werden:
          array = $.makeArray(itemsList.find('ul'));
          itemsList.find('ul').remove();
          itemsList = $.makeArray(itemsList);

          //Wenn der Array leer geblieben ist, also keine ul in der Liste gefunden wurden,
          //dann werden alle Listeneinträge einer ul hinzugefügt und der Array bekommt diese als Eintrag:
          if (array.length === 0 && itemsList.length !== 0) {
            for (var i = 0; i < itemsList.length; i++) {
              ul.append(itemsList[i]);
            }
            array = [ul];
          } else if (array.length > 0 && itemsList.length !== 0) {
            //Wenn der Array bereits mindestens eine ul enthält, also in der Liste ul gefunden wurden,
            //dann werden die übrig gebliebenen Einträge der Liste umgedreht, damit sie nacheinander der
            //ersten ul vorangestellt eingefügt werden können:
            itemsList.reverse();
            for (var j = 0; j < itemsList.length; j++) {
              $(array[0]).prepend(itemsList[j]);
            }
            $(array[0]).addClass('container');
          }

          if (array.length > 0) {
            for (var k = 1; k < array.length; k++) {
              var li = $(array[k]).find('li');
              for (var l = 0; l < li.length; l++) {
                $(array[0]).append(li[l]);
              }
            }
          }
          array = [array[0]];
        } else {
          //Wenn der Bereich nicht "Section" ist, dann werden alle Listeneinträge in einen Array geschrieben:
          array = $.makeArray(itemsList);
          var $tmp = $(array);

          $(array).each(function (index, item) {
            //Falls ein Eintrag im Array weitere Listen enthält, werden alle diese Listeneinträge dem Elternelement
            //im Array nachgestellt:
            $(item).find('ul > li').each(function (index2) {
              $tmp.splice(index + index2 + 1, 0, this);
            });
          });

          //Alle Array-Einträge werden einer ul hinzugefügt:
          $tmp.each(function () {
            ul.append(this);
          });
          array = [ul];
        }
      }

      return array;
    };


    /******
     * Diese Funktion fügt die Listen im Array der Area hinzu.
     *
     * @param $area       Menübereich
     * @param itemsList   Array bestehend aus Liste/n mit Menüpunkten
     * @private
     */
    Masternavi.prototype._addToMenu = function _addToMenu($area, itemsList) {
      var self = this;

      //Jeder Bereich wird geleert, bevor er mit Inhalt gefüllt wird:
      $area.empty();

      if(itemsList.length > 0) {
        //Die ul werden der entsprechenden Menubox hinzugefügt:
        $(itemsList).each(function () {
          $area.append(this);
        });
      }
    };


    /******
     * Diese Funktion entfernt alle leeren Listen und Listeneinträge entfernt.
     *
     * @param $area       Menübereich
     * @private
     */
    Masternavi.prototype._removeEmpty = function removeEmpty($area) {
      $area.find('ul, li').each(function (){
        if($(this).find('a').length === 0) {
          console.log(this, "Kein Link-Element gefunden - Leeres Listenelement wird mit allen Unterpunkten entfernt");
          $(this).remove();
        }
      });
    }


    /*****
     * Diese Funktion ändert die Namen von Links, die ein entsprechendes Attribut haben.
     *
     * @param $area         Menübereich
     * @param menuboxName   Name des Menübereich
     * @private
     */
    Masternavi.prototype._changeName = function _changeName($area, menuboxName) {
      var self = this;

      //Links können in den Menüboxen einen anderen Namen bekommen:
      $area.find('[data-menubox-item-name-' + menuboxName + ']').each(function () {
        if(this.tagName === "A"){
          $(this).text($(this).attr('data-menubox-item-name-' + menuboxName));
        }else {
          $(this).find('a').text($(this).attr('data-menubox-item-name-' + menuboxName));
        }
      });
    };


    /*****
     * Leere Menübereiche bekommen die Klasse "empty" und der Titel für Menübereiche
     * wird ins HTML geschrieben. Der erste nicht leere Menübereich bekommt die
     * Klasse "first".
     *
     * @private
     */
    Masternavi.prototype._updateCssAndTitle = function _updateCssAndTitle() {
      var self = this;
      var firstMarked = false;

      self.areas.each(function(){
        //Area zurücksetzen
        $(this).removeClass('first').removeClass('empty');

        if($(this).html() !== '') {
          //Wenn eine Area nicht leer ist, wird geschaut, ob eine Überschrift definiert ist
          var title;

          if($(this).data('menuboxName') === 'section') {
            var menuboxTitle = $(this).find('[data-menubox-title]').data('menuboxTitle');
            var firstLink = $(this).find('a').first();

            if(menuboxTitle) {
              title = menuboxTitle;
            }else if(!menuboxTitle && firstLink.length > 0) {
              title = firstLink.title || null;
            }else {
              title = null;
            }
          }else {
            title = $(this).data('menuboxTitle') || null;
          }

          if (title) {
            $(this).prepend('<h2>' + title + '</h2>');
          }

          //Die erste nicht leere Box wird markiert
          if(!firstMarked) {
            $(this).addClass('first');
            firstMarked = true;
          }
        }else {
          $(this).addClass('empty');
        }
      });
    };


    /*****
     * Fügt Wetter und Verkehr zum Bereich "Im SWR" hinzu
     *
     * @private
     */
    Masternavi.prototype._addWheaterTraffic = function _addWheaterTraffic() {
      var self = this;
      var $imswr = self.$element.find('[data-menubox-name="imswr"]');
      var $home = $imswr.find('li').first();
      var $weather = $('<li class="navi-weather"></li>').append($('.navbar-right .weather').clone());
      var $traffic = $('<li class="navi-traffic"></li>').append($('.navbar-right .verkehr').clone());

      $home.after($weather, $traffic);
    };


    /*****
     * Ermittelt die Breite der Scrollbar
     *
     * @private
     */
    Masternavi.prototype._getScrollbarWidth = function _getScrollbarWidth() {

      // Creating invisible container
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll'; // forcing scrollbar to appear
      outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
      document.body.appendChild(outer);

      // Creating inner element and placing it in the container
      const inner = document.createElement('div');
      outer.appendChild(inner);

      // Calculating difference between container's full width and the child width
      const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

      // Removing temporary elements from the DOM
      outer.parentNode.removeChild(outer);

      return scrollbarWidth;
    };

    // public
    Masternavi.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element.find('[data-menubox-name="section"]').empty();
      this.$element.find('[data-menubox-name="imswr"]').empty();
      this.$element.find('[data-menubox-name="tvradio"]').empty();

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Masternavi._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Masternavi(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Masternavi;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Masternavi._jQueryInterface.call($element, $element.data());
  });
  /*$(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Masternavi._jQueryInterface.call($element, $element.data());
    });
  });*/

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Masternavi._jQueryInterface;
  $.fn[NAME].Constructor = Masternavi;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Masternavi._jQueryInterface;
  };

  return Masternavi;

}(window.jQuery);
